import styled from 'styled-components';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

export const CollectionFormBottomSheet = styled(BottomSheet).attrs(
  ({ theme }) => ({
    hasHeadBorder: false,
    isPageLocked: true,
    isTitleCentered: true,
    shellBackground: theme.palette.secondary.background,
  })
)``;
